import * as types from './mutation-types'

const mutations = {
  [types.SET_LOGIN_STATE] (state, payload) {
    state.loginState = payload
  },
  [types.SET_TICKET] (state, payload) {
    state.ticket = payload
  },
  [types.SET_CIRD_TICKET] (state, payload) {
    state.cirdTicket = payload
  },
  [types.SET_PRIVILEGE_DICTIONARY] (state, payload) {
    state.privilegeDictionary = payload
  },
  [types.SET_QUERY_PRIVILEGE] (state, payload) {
    state.queryPrivilege = true
  },

  // 注册弹框显示和消失
  [types.REGISTER_SHOW] (state) {
    state.showRegister = true
  },
  [types.REGISTER_CLOSE] (state) {
    state.showRegister = false
  },

  // 登陆框控制
  [types.LOGIN_SHOW] (state) {
    state.showLogin = true
  },
  [types.LOGIN_CLOSE] (state) {
    state.showLogin = false
  },
  [types.SET_LOGIN_STATUS] (state, status) {
    state.isLogin = status
  }
}
export default mutations



// WEBPACK FOOTER //
// ./src/vuex/mutations.js